import Check from '@manomano-internal/tamagoshi-icons/esm/material/Check';
import { Outline } from '@manomano-internal/tamagoshi-icons/esm/material/ContentCopy';
import { useState, type FunctionComponent } from 'react';

import { Text } from '@/core/tamagoshi/Text/Text';
import { Gtm } from '@/domains/core/tracking/utils/Gtm';
import {
  codeLabelPrefix,
  copyAction,
} from '@/domains/loyalty/components/Coupon/translations';
import { GTM_CLICK_ON_COUPON_CODE } from '@/domains/productDiscovery/CommercialAnimation/services/tracking/clickOnCouponCode';

import styles from './CodeBlock.module.scss';

interface CodeBlockProps {
  couponCode: string;
  context: string;
}

export const CodeBlock: FunctionComponent<CodeBlockProps> = ({
  couponCode = '',
  context,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = (codeToCopy: string) => {
    Gtm.push(GTM_CLICK_ON_COUPON_CODE(context));
    setCopied(true);
    navigator.clipboard.writeText(codeToCopy);
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  return (
    <button
      type="button"
      data-testid="codeblock-copyButton"
      className={styles.codeBlock}
      onClick={() => handleCopy(couponCode)}
    >
      {copied ? (
        <Check className={styles.checkLogo} data-testid="codeblock-checkLogo" />
      ) : (
        <Outline className={styles.copyLogo} data-testid="codeblock-copyLogo" />
      )}

      <div className={styles.codeButtonText}>
        {!copied && (
          <Text tag="span" className={styles.codeLabelPrefix} type="small">
            {codeLabelPrefix}
          </Text>
        )}
        <Text
          className={copied ? styles.codeCopied : styles.code}
          tag="span"
          weight="bold"
          type="small"
          data-testid="codeblock-code"
        >
          {copied ? copyAction : couponCode}
        </Text>
      </div>
    </button>
  );
};

CodeBlock.displayName = 'CodeBlock';
